<template>
  <div>
    <h4></h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
<!--             <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td> -->
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Registrar Medicamento">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>Registrar Medicamento
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Medicamento</th>
          <th scope="col">Duración</th>
          <th scope="col">Dosis</th>
          <th scope="col">Frecuencia</th>
          <th scope="col">Indicación</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="medinter in datosPaginados" :key="medinter.idMedInter">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(medinter.idMedInter)" title="Editar">edit_square</i></td>
          <td>{{medinter.elementoNombre}}</td>
          <td>{{medinter.duracion}}</td>
          <td>{{medinter.dosisNombre}}</td>
          <td>{{medinter.frecuenciaNombre}}</td>
          <td>{{medinter.indicacion}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteInterMed(medinter.idMedInter)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
<!--
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMedInter" class="form-label">IdInterMed</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedInter" name="idMedInter" v-model="datoMedInter.idMedInter" disabled>
                </div>
              </div>
            </div>
--> 
<!-- Botón Lista de Valores  Interconsulta -->
<!--             <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idInterconsulta" class="form-label"> Interconsulta</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoMedInter.idInterconsulta">
                      <option v-for="interconsulta in interconsultas" :value="interconsulta.idInterconsulta" :key="interconsulta.idInterconsulta">
                        {{ interconsulta.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div> -->
<!-- Botón Lista de Valores  Interconsulta -->
<!-- Botón Lista de Valores  Elemento -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idElemento" class="form-label">Elemento</label>
                </div>
                <div class="col-10">
                  <div class="input-group">
                    <input type="text" class="form-control"
                          v-model="searchTextElem"
                          @input="filterElementos"
                          @keyup.enter="toggleDropdown"
                          placeholder="Buscar elemento...">
                    <button class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            ref="dropdownButton">
                      <i class="fa fa-search"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end shadow"
                        style="max-height: 250px; overflow-y: auto; width: 100%;"
                        ref="dropdownMenu">
                      <li v-for="elemento in filteredElementos" :key="elemento.idElemento">
                        <a class="dropdown-item text-truncate"
                          href="#"
                          @click="selectElemento(elemento)"
                          :title="elemento.codigo + ' - ' + elemento.nombre">
                          {{ elemento.codigo }} - {{ elemento.nombre }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Elemento -->
<!-- Botón Lista de Valores  Dosis -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idDosis" class="form-label"> Dosis</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idDosis" name="idDosis" v-model="datoMedInter.idDosis">
                      <option v-for="dosis in dosiss" :value="dosis.idDosis" :key="dosis.idDosis">
                        {{ dosis.dosisNombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Dosis -->
<!-- Botón Lista de Valores  Frecuencia -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idFrecuencia" class="form-label"> Frecuencia</label>
                  </div>
                  <div class="col-4">
                    <select class="form-control" id="idFrecuencia" name="idFrecuencia" v-model="datoMedInter.idFrecuencia">
                      <option v-for="frecuencia in frecuencias" :value="frecuencia.idFrecuencia" :key="frecuencia.idFrecuencia">
                        {{ frecuencia.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarFrecuencia(1)">qd</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarFrecuencia(2)">bid</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarFrecuencia(3)">tid</button>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Frecuencia -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="duracion" class="form-label">Duración</label>
                </div>
                <div class="col-4">
                  <input type="number" class="form-control" id="duracion" name="duracion" v-model="datoMedInter.duracion" min="1" required>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarDuracion(3)">3</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarDuracion(7)">7</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarDuracion(15)">15</button>
                </div>                
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="indicacion" class="form-label">Indicacion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="indicacion" name="indicacion" v-model="datoMedInter.indicacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoMedInter.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-success" @click.prevent="guardarInterMed" v-if="btnCrear" title="Guardar">
<span class="material-symbols-outlined align-middle" style="font-size:32px;">
  save
</span> Guardar
        </button>
        <button type="submit" class="btn btn-success" @click.prevent="guardarEditInterMed" v-if="btnEditar" title="Actualizar">
<span class="material-symbols-outlined align-middle" style="font-size:32px;">
  update
</span> Actualizar
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';
//import { format } from 'date-fns';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  props: {
    p_idInformeInter: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      medinters : [],
      datoMedInter : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      interconsultas: [],
      elementos: [],
      frecuencias: [],
      dosiss: [],
      filteredElementos: [],
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
/*
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, 'dd/MM/yyyy');
    },
  },
*/
  watch: {
    'datoMedInter.idElemento'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchDosiss(newVal);
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
//    this.fetchInterconsultas()
    this.fetchElementos()
    this.fetchFrecuencias()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.medinters.length / this.elementosPorPagina)
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmedinters/idinformeinter/'+this.p_idInformeInter).then(response=>{
      this.medinters=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.medinters.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    asignarFrecuencia(frecuencia) {
      this.datoMedInter.idFrecuencia = frecuencia;
    },
    asignarDosis(dosis) {
      this.datoMedInter.idDosis = dosis;
    },
    asignarDuracion(duracion) {
      this.datoMedInter.duracion = duracion;
      const elementoSeleccionado = this.elementos.find(f => f.idElemento === this.datoMedInter.idElemento);
      const frecuenciaSeleccionada = this.frecuencias.find(f => f.idFrecuencia === this.datoMedInter.idFrecuencia);
      const textoElemento = elementoSeleccionado ? elementoSeleccionado.nombre : '';
      const textoFrecuencia = frecuenciaSeleccionada ? frecuenciaSeleccionada.descripcion : '';
      this.datoMedInter.indicacion = `${textoElemento} ${textoFrecuencia} por ${duracion} días`;
    },    
    validarForm(){
      const requiredFields = [
        'idElemento'
        ,'idFrecuencia'
        ,'idDosis'
        ,'duracion'
        ,'indicacion'
      ];
      const requiredFieldsText = [
        'idElemento'
        ,'idFrecuencia'
        ,'idDosis'
        ,'duracion'
        ,'indicacion'
      ];
      return validarForm(this.datoMedInter, requiredFields, requiredFieldsText);
    },
    async guardarInterMed(){
      if(this.validarForm() === 1){
        try {
          this.datoMedInter.idInformeInter = this.p_idInformeInter;
          await api.post('/medinters', this.datoMedInter)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "InterMed creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditInterMed(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medinters', this.datoMedInter)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "InterMed creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoMedInter={}
      this.titulo   = 'Registrar Medicamento'
      this.btnCrear = true
      this.btnEditar= false
      this.searchTextElem = ''
    },
    abrirModalEditar(idMedInter){
      this.modalWindow = true
      if(idMedInter != null){    
        api.get('/vwmedinters/'+idMedInter).then(resp=>{
          this.datoMedInter = resp.data;
          this.searchTextElem = this.datoMedInter.elementoNombre;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Medicamento'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idMedInter){
      if(idMedInter != null){
        this.$router.push('/intermedmd/'+idMedInter)
      }
    },
    async deleteInterMed (idMedInter) {
      try{
        await api.delete('/medinters/'+idMedInter)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
/*     fetchInterconsultas() {
      fetch('http://localhost:8080/api/v1/interconsultas')
        .then(response => response.json())
        .then(data => {
          this.interconsultas = data;
        })
        .catch(error => {
          console.error('Error fetching interconsultas:', error);
        });
    }, */
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/vwelementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
          this.filteredElementos = data;  // Initialize the filtered elements
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
    filterElementos() {
      this.filteredElementos = this.elementos.filter(elemento =>
        elemento.nombre.toLowerCase().includes(this.searchTextElem.toLowerCase())
      );
    },
    selectElemento(elemento) {
      this.datoMedInter.idElemento = elemento.idElemento;
      this.searchTextElem = `${elemento.codigo} - ${elemento.nombre}`;
    },
    fetchFrecuencias() {
      fetch('http://localhost:8080/api/v1/vwfrecuencias')
        .then(response => response.json())
        .then(data => {
          this.frecuencias = data;
        })
        .catch(error => {
          console.error('Error fetching frecuencias:', error);
        });
    },
    fetchDosiss(idElemento) {
      fetch('http://localhost:8080/api/v1/vwdosismeds/idelemento/' + idElemento)
        .then(response => response.json())
        .then(data => {
          if (data.length > 0) {
            // Usamos los datos específicos del medicamento
            this.dosiss = data.map(dosis => ({
              idDosis: dosis.idDosis,
              dosisNombre: dosis.dosisNombre
            }));
          } else {
            // Si no hay datos específicos, se recurre al endpoint general
            fetch('http://localhost:8080/api/v1/vwdosiss')
              .then(response => response.json())
              .then(data => {
                this.dosiss = data.map(dosis => ({
                  idDosis: dosis.idDosis,
                  dosisNombre: dosis.nombre // Normalizamos aquí el nombre
                }));
              })
              .catch(error => console.error('Error fetching dosis general:', error));
          }
        })
        .catch(error => {
          console.error('Error fetching dosis específica:', error);
          // Intentar con el endpoint general en caso de error
          fetch('http://localhost:8080/api/v1/vwdosiss')
            .then(response => response.json())
            .then(data => {
              this.dosiss = data.map(dosis => ({
                idDosis: dosis.idDosis,
                dosisNombre: dosis.nombre // Normalizamos aquí el nombre
              }));
            })
            .catch(error => console.error('Error fetching dosis general:', error));
        });
    },
    toggleDropdown() {
      let dropdown = this.$refs.dropdownButton;
      dropdown.click();  // Simula un clic en el botón para desplegar el menú
    }    
  },
}
</script>
<style src="@/assets/css/listaFiltrada02.css" scoped></style>
<style scoped>
.btn-fixed-width {
    width: 100px; /* Establece el ancho que mejor se ajuste a tu diseño */
}
</style>